import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
  selector: 'tsData',
  templateUrl: './tsData.component.html'
})
export class tsDataComponent {
  search: any;
  prjId: any;
  showLoader: boolean;
  fuelPurchaseData: any;
  saveSuccess = false;
  errorInSuccess = false;
  
  respMsg: any;
  selectedRow: number;
  fuelDataNotFound = false;
  isBtnSave = false;
  syncing: any;
  loaderClass: any;
  purchaseDate: any;
  meterReading: any;
  refid: any;
  rate: any;
  qty: any;
  amount: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  private loadProducts(): void {
    this.gridinventory = process(this.fuelPurchaseData, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

	/*
   * Get All Vehicle Master List
  */

  getPurchaseFuelData() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'rectification/getFuelPurchaseData?prjid=' + this.prjId).subscribe((data) => {
      this.fuelPurchaseData = data;
      console.log('all data', this.fuelPurchaseData);
      if (this.fuelPurchaseData.length > 0) {
        this.gridinventory = process(this.fuelPurchaseData, this.state);
        this.fuelDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.fuelDataNotFound = true;
        this.loaderService.display(false);
        this.gridinventory = process(this.fuelPurchaseData, this.state);
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.fuelPurchaseData, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.fuelPurchaseData, this.state);
    }
  }

  syncData() {
    this.syncing = true;
    this.loaderClass = 'fas fa-sync fa-spin';
    this.http.get(environment.apiUrl + 'rectification/getFuelPurchaseData?prjid=' + this.prjId).subscribe((data) => {
      this.syncing = false;
      this.loaderClass = 'fas fa-sync';
      this.getPurchaseFuelData();
    });
    console.log("Refresh")
  }

  updateInventory(data){
    this.clearAllFields();
    this.refid = data.REFID
    this.purchaseDate = data.PURCHASEDATE
    this.meterReading = data.METERREADING
    this.rate = data.RATE
    this.qty = data.QTY
    $('#updateModal').modal('show')
  }

	/*
  Update Part Master
*/
  onClickToUpdateFuelPurchaseData() {
    var amount = this.amount.toFixed(2);
    var data = {
      creatDate: this.purchaseDate,
      modDate: this.purchaseDate,
      meterReading: this.meterReading,
      refid: this.refid,
      rate: this.rate,
      qty: this.qty,
      amount: amount,
    }

    this.http.post(environment.apiUrl + 'rectification/updateDate', data).subscribe((data) => {
      var code: any;
      code = data;
      this.syncData();
      Swal('Quantity has been updated successfully.', 'success');
    });


  }

  clearAllFields() {
    this.purchaseDate = null;
    this.meterReading = null;
    this.refid = null;
    this.rate = null;
    this.qty = null;
    this.amount = null;
  }

  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return true;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.getPurchaseFuelData();
  }
}



// WEBPACK FOOTER //
// ./src/app/dataRectify/weighbridgeData/tsData/tsData.component.ts